
import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

const Footer = () => {
  const { t, language } = useLanguage();

  const footerLinks = {
    company: [
      { key: 'about_us', href: '/about', en: 'About Us', ar: 'عنا' },
      { key: 'contact', href: '/contact', en: 'Contact', ar: 'اتصل بنا' },
      { key: 'careers', href: '/careers', en: 'Careers', ar: 'الوظائف' },
    ],
    support: [
      { key: 'help_center', href: '/help', en: 'Help Center', ar: 'مركز المساعدة' },
      { key: 'safety', href: '/safety', en: 'Safety', ar: 'الأمان' },
      { key: 'community_guidelines', href: '/guidelines', en: 'Community Guidelines', ar: 'إرشادات المجتمع' },
    ],
    legal: [
      { key: 'privacy_policy', href: '/privacy', en: 'Privacy Policy', ar: 'سياسة الخصوصية' },
      { key: 'terms_service', href: '/terms', en: 'Terms of Service', ar: 'شروط الخدمة' },
      { key: 'cookie_policy', href: '/cookies', en: 'Cookie Policy', ar: 'سياسة ملفات تعريف الارتباط' },
    ],
  };

  return (
    <footer className={`bg-muted border-t mt-16 ${language === 'ar' ? 'rtl' : 'ltr'}`}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <h3 className="text-lg font-bold text-primary mb-4">
              Maskan
            </h3>
            <p className="text-muted-foreground text-sm mb-4">
              {t('footer_description', 'منصة الإسكان الطلابي الرائدة في مصر', 'Leading student housing platform in Egypt')}
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4">
              {t('company', 'الشركة', 'Company')}
            </h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                  >
                    {language === 'ar' ? link.ar : link.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="font-semibold mb-4">
              {t('support', 'الدعم', 'Support')}
            </h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                  >
                    {language === 'ar' ? link.ar : link.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold mb-4">
              {t('legal', 'القانونية', 'Legal')}
            </h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.href}
                    className="text-muted-foreground hover:text-foreground transition-colors text-sm"
                  >
                    {language === 'ar' ? link.ar : link.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="text-center">
          <p className="text-muted-foreground text-sm">
            © 2024 Maskan. {t('all_rights_reserved', 'جميع الحقوق محفوظة', 'All rights reserved')}.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
